import { $_cms_server } from '@/_helpers'

export const pagesService = {
  loadPagesList,
  get,
  loadTopNav
}

function loadPagesList () {
  return $_cms_server.get('page/list').then(response => response.data)
}

function get (alias) {
  return $_cms_server.get('page/'+alias).then(response => response.data)
}

function loadTopNav () {
  return $_cms_server.get('page/listnav').then(response => response.data)
}